import React, { ReactNode } from 'react';
import SplitSection from '@fuww/library/src/SplitSection';
import {
  SplitHeroDesktopContainer,
  SplitHeroMobileContainer,
} from '@fuww/library/src/ImageContainer';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import { DesktopOnlyImage, MobileOnlyImage } from './Company/HeaderImage';
import getSourceSet from '../lib/getSourceSet';
import {
  splitHeroImageConfigurations,
  splitHeroMobileImageConfigurations,
} from '../lib/imageConfigurations';

const mobilePreloadMediaQuery = `(max-width: ${breakpoints.md - 1}px)`;
const desktopPreloadMediaQuery = `(min-width: ${breakpoints.md}px)`;

interface SplitHeroProperties {
  imageUrls: { mobile: string[]; desktop: string[] };
  alt: string;
  content: ReactNode;
  className?: string;
}

const SplitHero = ({
  imageUrls,
  alt,
  content,
  className,
}: SplitHeroProperties) => (
  <SplitSection
    content={content}
    className={className}
    image={(
      <>
        <MobileOnlyImage
          title={alt}
          imageUrls={imageUrls.mobile}
          MobileOnlyContainer={SplitHeroMobileContainer}
          srcSet={getSourceSet(
            splitHeroMobileImageConfigurations,
            imageUrls.mobile,
          )}
          sizes="100vw"
          preloadMediaQuery={mobilePreloadMediaQuery}
          loadStrategy="on-visible"
          placeholderLoadStrategy="on-visible"
        />
        <DesktopOnlyImage
          title={alt}
          imageUrls={imageUrls.desktop}
          DesktopOnlyContainer={SplitHeroDesktopContainer}
          srcSet={getSourceSet(
            splitHeroImageConfigurations,
            imageUrls.desktop,
          )}
          sizes="50vw"
          disableRoundedCorners
          preloadMediaQuery={desktopPreloadMediaQuery}
        />
      </>
    )}
  />
);

export default SplitHero;
